// Import the latest Bootstrap JavaScript so it can be used.
// The Bootstrap package is managed by the npm package.json.
import bootstrap, { Tooltip } from 'bootstrap';

// Initialise Tooltips
// Taken from Bootstrap's Official Documentation
// see: https://getbootstrap.com/docs/5.3/components/tooltips/#enable-tooltips
document.addEventListener('DOMContentLoaded', function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].
        filter(el => {
            const title = el.getAttribute('title')
            const bsTitle = el.getAttribute('data-bs-title')
            return (title && title.trim()) || (bsTitle && bsTitle.trim())
        }).map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
});